<template lang="pug" functional>
span.status-box
  .status-box__item.status-box__item_success( v-if="props.value" ) 
  .status-box__item.status-box__item_error( v-else )

</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.status-box {
  display: inline-block;
  &__item {
    width: 7px;
    display: inline-block;
    height: 7px;
    border-radius: 50%;
    &_success {
      background-color: #1c7e48;
    }
    &_error {
      background-color: $error-check-color;
    }
  }
 
}
</style>